var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/*****************
 ** WEBPACK FOOTER
 ** ./math-input/~/lodash/_getPrototype.js
 ** module id = 549
 ** module chunks = 0 2
 **/